import { FieldType } from "../api.js";
import { BaseModelConvertSpec } from "./base.specs.js";
const GameTxModelConvertSpec = {
  ...BaseModelConvertSpec,
  playAmt: FieldType.BigNumber,
  earnAmt: FieldType.BigNumber,
  timestamp: FieldType.DateTime
};
const FundingModelConvertSpec = {
  ...BaseModelConvertSpec,
  reqAmount: FieldType.BigNumber,
  netAmount: FieldType.BigNumber
};
export {
  FundingModelConvertSpec,
  GameTxModelConvertSpec
};
